<ion-card>
  <ion-card-header>
    <ion-card-title [innerHTML]="'post_suggestions'|translate"></ion-card-title>
  </ion-card-header>
  <ion-card-content>
    <pipeline-post-suggestions-slider [hidden]="!view.loaded"></pipeline-post-suggestions-slider>
  </ion-card-content>
</ion-card>
